import { SvgIcon } from "@mui/material";
import { IconProps } from "../_interface";

const TicketLogo = (props: IconProps) => {
  return(
    <SvgIcon {...props} color="inherit" viewBox="0 0 28 28">
     <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="28" height="28" rx="14" fill="#F5E4E7"/>
      <path d="M7 5.44447C7 4.58536 7.69645 3.88892 8.55556 3.88892H19.7037C20.5628 3.88892 21.2593 4.58536 21.2593 5.44447V21H18.6667H16.625H14.3889H11.9907H7V5.44447Z" fill="#D14C5E"/>
      <path d="M7 5.44447V21H9.33333H11.9907H14.1296V3.88892H8.55556C7.69645 3.88892 7 4.58536 7 5.44447Z" fill="#BE1A2E"/>
      <rect x="9.33337" y="7" width="7" height="1.55556" rx="0.777778" fill="#FDFDFD"/>
      <rect x="9.33337" y="10.8889" width="3.88889" height="1.55556" rx="0.777778" fill="#FDFDFD"/>
      <rect x="9.33337" y="14.7778" width="7.77778" height="1.55556" rx="0.777778" fill="#FDFDFD"/>
      <path d="M22.1013 24.8889C20.5066 24.8889 19.1361 23.929 18.536 22.5555H8.8791V19.4444H18.536C19.1361 18.0709 20.5066 17.1111 22.1013 17.1111C23.696 17.1111 25.0665 18.0709 25.6666 19.4444H22.8791C22.02 19.4444 21.3235 20.1409 21.3235 21C21.3235 21.8591 22.02 22.5555 22.8791 22.5555H25.6666C25.0665 23.929 23.696 24.8889 22.1013 24.8889Z" fill="#98A2A7"/>
      <path d="M4.21265 20.972L5.7682 23.6663L8.87931 23.6663L10.4349 20.972L8.87931 18.2777L5.7682 18.2777L4.21265 20.972Z" fill="#2E434D"/>
      <circle cx="1.55556" cy="1.55556" r="1.55556" transform="matrix(-1 0 0 1 8.87939 19.4444)" fill="#C9CED0"/>
      </svg>
   </SvgIcon>
  );
}

export default TicketLogo;